import React, { useState } from "react";
import {
  Box,
  List,
  Divider,
  Button,
  Typography,
  Collapse,
  Chip,
} from "@mui/material";
import FamilyNestedListItem from "./FamilyNestedListItem";
import NestedListExpandIcon from "./NestedListExpandIcon";

const FamilyFilters = ({
  families,
  filters,
  toggleFamilyTarget,
  toggleCategoryTarget,
  toggleSubcategoryTarget,
  clearFilters,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const selectedCount = Object.keys(filters).reduce((familyAcc, familyId) => {
    const categories = filters[familyId];
    const categoryCount = Object.keys(categories).reduce((catAcc, categoryId) => {
      const subcategoryCount = Object.keys(categories[categoryId]).length;
      return catAcc + 1 + subcategoryCount;
    }, 0);
    return familyAcc + 1 + categoryCount;
  }, 0);

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    clearFilters();
  };

  return (
    <>
      <Box
        sx={{
          marginTop: 4,
          border: "1px solid",
          borderColor: (theme) => theme.palette.terrain[300],
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          borderBottomLeftRadius: isExpanded ? 0 : 8,
          borderBottomRightRadius: isExpanded ? 0 : 8,
        }}
      >
        <Box
          onClick={handleToggleExpanded}
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: 2,
            backgroundColor: (theme) => theme.palette.terrain[100],
            borderTopLeftRadius: 7,
            borderTopRightRadius: 7,
            cursor: "pointer",
          }}
        >
          <Typography variant="body2">Classification</Typography>
          <Box sx={{ flexGrow: 1 }} />
          {selectedCount > 0 ? (
            <Chip
              size="small"
              label={selectedCount}
              color="primary"
              sx={{
                marginRight: 2,
                borderRadius: 10,
                "& .MuiChip-label": { paddingLeft: 2.5, paddingRight: 2.5 },
              }}
            />
          ) : null}
          <Button
            variant="outlined"
            sx={{ marginRight: 2 }}
            onClick={handleClear}
          >
            <Typography variant="body1">Clear</Typography>{" "}
          </Button>
          <NestedListExpandIcon
            isOpen={isExpanded}
            toggleOpen={handleToggleExpanded}
          />
        </Box>
        <Collapse in={isExpanded} timeout="auto">
          <List
            disablePadding
            sx={{
              overflow: "scroll",
              maxHeight: { xs: "200px", md: "300px" },
              borderTop: "1px solid",
              borderColor: (theme) => theme.palette.terrain[300],
            }}
          >
            {families.map((x) => (
              <FamilyNestedListItem
                key={x.id}
                family={x}
                filters={filters}
                toggleCategoryTarget={toggleCategoryTarget}
                toggleFamilyTarget={toggleFamilyTarget}
                toggleSubcategoryTarget={toggleSubcategoryTarget}
              />
            ))}
          </List>
        </Collapse>
      </Box>
      <Divider sx={{ marginLeft: -8, marginRight: -8 }} />
    </>
  );
};

export default FamilyFilters;
